export const splitAt = (index) => (x) => [x.slice(0, index), x.slice(index)];
